import { SearchSetting } from '@/models/search-setting'

export const RoomOptionDisplayType = {
  GuestName: 'guestName',
  RoomAssignName: 'roomAssignName',
} as const
export type RoomOptionDisplayType = (typeof RoomOptionDisplayType)[keyof typeof RoomOptionDisplayType]

export type SelfCheckinSetting = {
  requiredAccompanyNameInput: boolean
  requiredAddressInput: boolean
  requiredBirthDateInput: boolean
  requiredEmailInput: boolean
  requiredForeignIdentify: boolean
  requiredIdentifyVerification: boolean
  requiredFuriganaInput: boolean
  requiredGenderInput: boolean
  requiredIdentify: boolean
  requiredPreCheckinIdentify: boolean
  isPreCheckinIdentifySkippable: boolean
  requiredTelephoneInput: boolean
  isFrontDescGuidance: boolean
  isCheckinAllowedBeforeRoomInspection: boolean
  roomOptionDisplayType: RoomOptionDisplayType
}

// 設定のレコードはセルフチェックインプラグインの追加時にだけ作られるため、レコードが無い施設（予約連携だけの施設など）では
// searchItems 以外の設定値が返らない
export type SelfCheckinSettingResponse = {
  searchItems: SearchSetting[]
} & Partial<SelfCheckinSetting>

// レコードが無い施設で最初に保存するとレコードが作られ、送らなかった項目にはテーブルの既定値が入る。
// 取得結果に無い項目の表示をその値に合わせるため、テーブルの既定値（aipass_backend の self_checkin_setting のマイグレーション）と同じ値にする
export const defaultSelfCheckinSetting: SelfCheckinSetting = {
  requiredAccompanyNameInput: false,
  requiredAddressInput: true,
  requiredBirthDateInput: true,
  requiredEmailInput: false,
  requiredForeignIdentify: true,
  requiredIdentifyVerification: false,
  requiredFuriganaInput: true,
  requiredGenderInput: true,
  requiredIdentify: true,
  requiredPreCheckinIdentify: false,
  isPreCheckinIdentifySkippable: true,
  requiredTelephoneInput: true,
  isFrontDescGuidance: true,
  isCheckinAllowedBeforeRoomInspection: true,
  roomOptionDisplayType: RoomOptionDisplayType.RoomAssignName,
}
